module.exports = __webpack_public_path__ + "img/1-06.c34aa607.jpg";